/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsvat101Inputs */

const en_ticketsvat101 = /** @type {(inputs: Ticketsvat101Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10%`)
};

const de_ticketsvat101 = /** @type {(inputs: Ticketsvat101Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 %`)
};

/**
* | output |
* | --- |
* | "10%" |
*
* @param {Ticketsvat101Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsvat101 = /** @type {((inputs?: Ticketsvat101Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsvat101Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsvat101(inputs)
	return de_ticketsvat101(inputs)
});
export { ticketsvat101 as "ticketsVat10" }